// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card shell ───────────────────────────────────────────────────────────── */

.scl--cms-components-workflowCard {
  /* Figma: width 375px, height 92px — flex context makes it fluid */
  position: relative;
  flex: 1;
  height: 92px;
  min-width: 0;

  /* Background & shadow */
  background: #FFFFFF;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;

  /* Left accent border — color injected via inline style */
  border-left: 5px solid transparent;

  /* Internal layout */
  display: flex;
  flex-direction: row;
  align-items: center;

  /* Left padding accounts for: 5px border + 18px gap + 50px icon + 12px gap */
  padding: 0 20px 0 80px;
  box-sizing: border-box;

  overflow: hidden;
}

/* ── Gradient icon badge ──────────────────────────────────────────────────── */

.scl--cms-components-workflowCard-icon {
  /* Figma: 50×50px, left:18px from card edge (inside the 5px border) */
  position: absolute;
  left: 18px; /* from inner edge — border-left is separate from padding */
  top: 50%;
  transform: translateY(-50%);

  width: 50px;
  height: 50px;
  border-radius: 10px;

  /* Centre the SVG icon */
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  flex-shrink: 0;
}

/* ── PNG icon image ───────────────────────────────────────────────────────── */

.scl--cms-components-workflowCard-iconImg {
  /* Figma: icon area is 30×30px inside the 50×50px badge (10px padding each side) */
  width: 30px;
  height: 30px;
  object-fit: contain;
  /* White icons on gradient bg — no filter needed if PNGs are already white */
  display: block;
}

/* ── Label ────────────────────────────────────────────────────────────────── */

.scl--cms-components-workflowCard-label {
  /* Figma: font-size 18px, weight 400, line-height 22px */
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;

  /* Stretch to fill space between icon and value */
  flex: 1;
  min-width: 0;

  /* Colour injected via inline style */
}

/* ── Large numeric value ──────────────────────────────────────────────────── */

.scl--cms-components-workflowCard-value {
  /* Figma: font-size 48px, weight 400, line-height 48px */
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  line-height: 48px;

  flex-shrink: 0;

  /* Colour injected via inline style */
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/workflow-dsb-op/workflow-card/css/workflowCard.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,kEAAkE;EAClE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,YAAY;;EAEZ,wBAAwB;EACxB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;;EAElB,yDAAyD;EACzD,kCAAkC;;EAElC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB,4EAA4E;EAC5E,sBAAsB;EACtB,sBAAsB;;EAEtB,gBAAgB;AAClB;;AAEA,gFAAgF;;AAEhF;EACE,qEAAqE;EACrE,kBAAkB;EAClB,UAAU,EAAE,2DAA2D;EACvE,QAAQ;EACR,2BAA2B;;EAE3B,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,kFAAkF;EAClF,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4EAA4E;EAC5E,cAAc;AAChB;;AAEA,gFAAgF;;AAEhF;EACE,wDAAwD;EACxD,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,iDAAiD;EACjD,OAAO;EACP,YAAY;;EAEZ,qCAAqC;AACvC;;AAEA,gFAAgF;;AAEhF;EACE,wDAAwD;EACxD,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;;EAEjB,cAAc;;EAEd,qCAAqC;AACvC","sourcesContent":["/* ── Card shell ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-workflowCard {\n  /* Figma: width 375px, height 92px — flex context makes it fluid */\n  position: relative;\n  flex: 1;\n  height: 92px;\n  min-width: 0;\n\n  /* Background & shadow */\n  background: #FFFFFF;\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n\n  /* Left accent border — color injected via inline style */\n  border-left: 5px solid transparent;\n\n  /* Internal layout */\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  /* Left padding accounts for: 5px border + 18px gap + 50px icon + 12px gap */\n  padding: 0 20px 0 80px;\n  box-sizing: border-box;\n\n  overflow: hidden;\n}\n\n/* ── Gradient icon badge ──────────────────────────────────────────────────── */\n\n.scl--cms-components-workflowCard-icon {\n  /* Figma: 50×50px, left:18px from card edge (inside the 5px border) */\n  position: absolute;\n  left: 18px; /* from inner edge — border-left is separate from padding */\n  top: 50%;\n  transform: translateY(-50%);\n\n  width: 50px;\n  height: 50px;\n  border-radius: 10px;\n\n  /* Centre the SVG icon */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  flex-shrink: 0;\n}\n\n/* ── PNG icon image ───────────────────────────────────────────────────────── */\n\n.scl--cms-components-workflowCard-iconImg {\n  /* Figma: icon area is 30×30px inside the 50×50px badge (10px padding each side) */\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n  /* White icons on gradient bg — no filter needed if PNGs are already white */\n  display: block;\n}\n\n/* ── Label ────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-workflowCard-label {\n  /* Figma: font-size 18px, weight 400, line-height 22px */\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n\n  /* Stretch to fill space between icon and value */\n  flex: 1;\n  min-width: 0;\n\n  /* Colour injected via inline style */\n}\n\n/* ── Large numeric value ──────────────────────────────────────────────────── */\n\n.scl--cms-components-workflowCard-value {\n  /* Figma: font-size 48px, weight 400, line-height 48px */\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 48px;\n  line-height: 48px;\n\n  flex-shrink: 0;\n\n  /* Colour injected via inline style */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
